var _mask, _path, _path2, _path3, _g, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAreaComumFeed = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 172,
  height: 156,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
  id: "a",
  maskUnits: "userSpaceOnUse",
  x: 2,
  y: 0,
  width: 172,
  height: 156
}, /*#__PURE__*/React.createElement("path", {
  d: "M2 0h172v156H2V0z",
  fill: "#fff"
}))), /*#__PURE__*/React.createElement("g", {
  mask: "url(#a)"
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M40.86 82.435c3.294 5.556 4.068 12.18 4.134 18.608.165 15.929-11.527 39.156-21.901 51.353l17.636.148s30.662-31.759 10.539-80.252",
  fill: "#ACACAC"
})), /*#__PURE__*/React.createElement("path", {
  style: {
    mixBlendMode: "multiply"
  },
  d: "M40.86 82.435c3.294 5.556 4.068 12.18 4.134 18.608.165 15.929-11.527 39.156-21.901 51.353l17.636.148s30.662-31.759 10.539-80.252",
  fill: "url(#paint0_linear)"
}), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M50.23 75.728a24.478 24.478 0 0124.157-5.047 18.02 18.02 0 00-24.7-2.137 18.996 18.996 0 018.464-9.682 28.245 28.245 0 0112.531-3.535 16.752 16.752 0 00-15.512-.838 26 26 0 00-11.658 10.817 27.508 27.508 0 014.117-9.863 13.46 13.46 0 018.842-5.704 16.61 16.61 0 00-16.335 2.925 15.897 15.897 0 00-4.913 6.813 15.87 15.87 0 00-.752 8.36 21.872 21.872 0 00-10.833.763 21.839 21.839 0 00-9.125 5.878A21.777 21.777 0 009.952 95.01a24.086 24.086 0 015.961-11.062 15.348 15.348 0 0111.395-4.735 19.117 19.117 0 00-5.66 5.667 19.081 19.081 0 00-2.837 7.484 28.278 28.278 0 002.338 15.797 30.646 30.646 0 013.162-13.791A20.108 20.108 0 0134.504 84.8a20.026 20.026 0 002.553 23.704 30.692 30.692 0 013.622-22.783l9.551-9.994z",
  fill: "#EE8322"
})), /*#__PURE__*/React.createElement("path", {
  style: {
    mixBlendMode: "multiply"
  },
  d: "M50.23 75.728a24.478 24.478 0 0124.157-5.047 18.02 18.02 0 00-24.7-2.137 18.996 18.996 0 018.464-9.682 28.245 28.245 0 0112.531-3.535 16.752 16.752 0 00-15.512-.838 26 26 0 00-11.658 10.817 27.508 27.508 0 014.117-9.863 13.46 13.46 0 018.842-5.704 16.61 16.61 0 00-16.335 2.925 15.897 15.897 0 00-4.913 6.813 15.87 15.87 0 00-.752 8.36 21.872 21.872 0 00-10.833.763 21.839 21.839 0 00-9.125 5.878A21.777 21.777 0 009.952 95.01a24.086 24.086 0 015.961-11.062 15.348 15.348 0 0111.395-4.735 19.117 19.117 0 00-5.66 5.667 19.081 19.081 0 00-2.837 7.484 28.278 28.278 0 002.338 15.797 30.646 30.646 0 013.162-13.791A20.108 20.108 0 0134.504 84.8a20.026 20.026 0 002.553 23.704 30.692 30.692 0 013.622-22.783l9.551-9.994z",
  fill: "url(#paint1_linear)"
}), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M62.811 152.988H21.775S70.09 123.284 86.458 48.933l20.863.493s1.235 35.737-44.51 103.562z",
  fill: "#D7D8D6"
})), /*#__PURE__*/React.createElement("mask", {
  id: "b",
  maskUnits: "userSpaceOnUse",
  x: 21,
  y: 48,
  width: 87,
  height: 105
}, /*#__PURE__*/React.createElement("path", {
  style: {
    mixBlendMode: "multiply"
  },
  d: "M62.811 152.988H21.775S70.09 123.284 86.458 48.933l20.863.493s1.236 35.737-44.51 103.562z",
  fill: "url(#paint2_linear)"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#b)",
  stroke: "#ACACAC",
  strokeMiterlimit: 10
}, /*#__PURE__*/React.createElement("path", {
  d: "M74.93 55.936h35.866M64.524 66.506h46.272M64.524 77.076h46.272M64.524 87.645h46.272M64.524 98.232h46.272M44.73 108.802h66.066M44.73 119.372h66.066M20.985 129.958h89.811M20.985 140.528h89.811"
}))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M119.672 81.925c-3.162 5.392-3.952 11.835-4.018 18.082-.148 15.485 14.507 40.701 24.503 52.603h-20.238s-29.92-33.419-10.407-80.548",
  fill: "#ACACAC"
})), /*#__PURE__*/React.createElement("path", {
  style: {
    mixBlendMode: "multiply"
  },
  d: "M119.672 81.925c-3.162 5.392-3.952 11.835-4.018 18.082-.148 15.485 14.507 40.701 24.503 52.603h-20.238s-29.92-33.419-10.407-80.548",
  fill: "url(#paint3_linear)"
}), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M107.865 76.188c-1.219-6.74-8.234-7.529-15.068-8.367-6.834-.838-13.569 1.282-20.04 3.534a23.32 23.32 0 017.633-9.045A23.386 23.386 0 01103.193 60a23.347 23.347 0 019.299 7.329 21.497 21.497 0 00-3.751-9.164 21.54 21.54 0 00-7.463-6.518 32.21 32.21 0 00-19.48-3.14 30.607 30.607 0 0138.005 4.29c3.623 3.847 6.258 9.206 4.94 14.334 5.994-3.468 13.948-2.597 19.942.872a24.976 24.976 0 017.519 7.077 24.93 24.93 0 014.008 9.509 23.643 23.643 0 00-11.936-9.077 23.684 23.684 0 00-15.004-.08 22.219 22.219 0 017.432 4.95 22.17 22.17 0 014.879 7.47 22.14 22.14 0 01-.521 17.465c-3.688-9.681-11.527-23.375-22.774-21.37l-10.423-7.758z",
  fill: "#AC41D8"
})), /*#__PURE__*/React.createElement("path", {
  style: {
    mixBlendMode: "multiply"
  },
  d: "M107.865 76.188c-1.219-6.74-8.234-7.529-15.068-8.367-6.834-.838-13.569 1.282-20.04 3.534a23.32 23.32 0 017.633-9.045A23.386 23.386 0 01103.193 60a23.347 23.347 0 019.299 7.329 21.497 21.497 0 00-3.751-9.164 21.54 21.54 0 00-7.463-6.518 32.21 32.21 0 00-19.48-3.14 30.607 30.607 0 0138.005 4.29c3.623 3.847 6.258 9.206 4.94 14.334 5.994-3.468 13.948-2.597 19.942.872a24.976 24.976 0 017.519 7.077 24.93 24.93 0 014.008 9.509 23.643 23.643 0 00-11.936-9.077 23.684 23.684 0 00-15.004-.08 22.219 22.219 0 017.432 4.95 22.17 22.17 0 014.879 7.47 22.14 22.14 0 01-.521 17.465c-3.688-9.681-11.527-23.375-22.774-21.37l-10.423-7.758z",
  fill: "url(#paint4_linear)"
}), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M161.004 46.385c-.346-.854-.708-1.643-1.071-2.58-4.726-11.195-16.22-17.326-27.994-18.083a38.584 38.584 0 00-9.88.641c-3.211.625-6.142 2.269-9.205 2.96 4.199-7.003 15.627-11.409 23.334-12.28a30.975 30.975 0 0113.462 1.304 30.939 30.939 0 0111.617 6.915c-3.87-9.863-13.882-16.668-24.338-18.444-10.457-1.775-21.407.937-30.909 5.787a26.85 26.85 0 00-9.682 7.561c-3.854-5.26-8.119-10.389-13.718-13.71a36.886 36.886 0 00-17.405-4.7 51.114 51.114 0 00-29.876 8.335 50.976 50.976 0 00-19.525 24.064c8.381-7.233 17.949-13.594 28.817-15.698 10.868-2.104 23.235.838 30.118 9.485a44.238 44.238 0 00-39.389 5.934 44.108 44.108 0 00-13.28 15.608A44.025 44.025 0 0017.295 69.4a57.45 57.45 0 0116.951-19.713 57.571 57.571 0 0123.92-10.238 34.968 34.968 0 0113.009 0 44.58 44.58 0 00-19.4 15.267 44.465 44.465 0 00-8.281 23.232c8.744-14.811 26.001-25.841 42.962-29.014 1.647.148 21.193.56 21.243.51 6.06-.164 13.371 2.745 18.344 6.329 7.525 5.44 14.211 12.674 16.632 21.633 2.338-11.803-.659-27.568-14.145-36.165a41.54 41.54 0 0119.637 4.055 41.461 41.461 0 0115.437 12.778 27.026 27.026 0 00-2.601-11.688z",
  fill: "#00D38D"
})), /*#__PURE__*/React.createElement("path", {
  style: {
    mixBlendMode: "multiply"
  },
  d: "M161.004 46.385c-.346-.854-.708-1.643-1.071-2.58-4.726-11.195-16.22-17.326-27.994-18.083a38.584 38.584 0 00-9.88.641c-3.211.625-6.142 2.269-9.205 2.96 4.199-7.003 15.627-11.409 23.334-12.28a30.975 30.975 0 0113.462 1.304 30.939 30.939 0 0111.617 6.915c-3.87-9.863-13.882-16.668-24.338-18.444-10.457-1.775-21.407.937-30.909 5.787a26.85 26.85 0 00-9.682 7.561c-3.854-5.26-8.119-10.389-13.718-13.71a36.886 36.886 0 00-17.405-4.7 51.114 51.114 0 00-29.876 8.335 50.976 50.976 0 00-19.525 24.064c8.381-7.233 17.949-13.594 28.817-15.698 10.868-2.104 23.235.838 30.118 9.485a44.238 44.238 0 00-39.389 5.934 44.108 44.108 0 00-13.28 15.608A44.025 44.025 0 0017.295 69.4a57.45 57.45 0 0116.951-19.713 57.571 57.571 0 0123.92-10.238 34.968 34.968 0 0113.009 0 44.58 44.58 0 00-19.4 15.267 44.465 44.465 0 00-8.281 23.232c8.744-14.811 26.001-25.841 42.962-29.014 1.647.148 21.193.56 21.243.51 6.06-.164 13.371 2.745 18.344 6.329 7.525 5.44 14.211 12.674 16.632 21.633 2.338-11.803-.659-27.568-14.145-36.165a41.54 41.54 0 0119.637 4.055 41.461 41.461 0 0115.437 12.778 27.026 27.026 0 00-2.601-11.688z",
  fill: "url(#paint5_linear)"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 23.093,
  y1: 112.418,
  x2: 58.102,
  y2: 112.418,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D7D8D6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 9.063,
  y1: 78.588,
  x2: 74.338,
  y2: 78.588,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EE8322"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.06,
  stopColor: "#F19A4C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.13,
  stopColor: "#F4B276"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.21,
  stopColor: "#F7C79B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.29,
  stopColor: "#FAD8BA"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.38,
  stopColor: "#FCE6D3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.48,
  stopColor: "#FDF1E7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6,
  stopColor: "#FEF9F5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.74,
  stopColor: "#FFFEFD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear",
  x1: 682.218,
  y1: 6326.54,
  x2: 5127.37,
  y2: 6326.54,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D7D8D6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear",
  x1: 2226.31,
  y1: 5488.9,
  x2: 3068.6,
  y2: 5488.9,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D7D8D6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear",
  x1: 72.724,
  y1: 74.528,
  x2: 156.13,
  y2: 74.528,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#AC41D8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.11,
  stopColor: "#AF47D9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.26,
  stopColor: "#B658DD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.44,
  stopColor: "#C375E3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.63,
  stopColor: "#D49CEB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.83,
  stopColor: "#EACEF5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint5_linear",
  x1: 15.748,
  y1: 39.859,
  x2: 163.556,
  y2: 39.859,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00D38D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgAreaComumFeed);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/areaComumFeed.a2281e02cdc35802745d0c51da4986ab.svg";